module.exports = __webpack_public_path__ + "img/hr-stone-path-4.c5e64e93.png";